(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3105],{

/***/ 43105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content012": function() { return /* binding */ Content012; },
  "default": function() { return /* binding */ Content012_Content012; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/widgets/index.js + 3 modules
var widgets = __webpack_require__(68642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/contexts/PageData/index.js + 3 modules
var PageData = __webpack_require__(65202);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./src/components/widgets/content/Content012/Content012.module.scss
var Content012_module = __webpack_require__(74622);
var Content012_module_default = /*#__PURE__*/__webpack_require__.n(Content012_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/shared/utils/index.js + 10 modules
var utils = __webpack_require__(63414);
// EXTERNAL MODULE: ./src/components/widgets/content/Content012/Item/Item.module.scss
var Item_module = __webpack_require__(69819);
var Item_module_default = /*#__PURE__*/__webpack_require__.n(Item_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content012/Item/Item.jsx






var Item = function(param) {
    var title = param.title, slug = param.slug, articleDate = param.date, eventDate = param.eventDate, previewImage = param.previewImage, contentType = param.contentType;
    var locale = (0,router.useRouter)().locale;
    var itemDate = (0,react.useMemo)(function() {
        return contentType === "event" ? eventDate : articleDate;
    }, [
        contentType,
        eventDate,
        articleDate
    ]);
    var date = (0,react.useMemo)(function() {
        return (0,utils/* formatDate */.p6)(itemDate, locale);
    }, [
        locale,
        itemDate
    ]);
    var directoryLink = (0,react.useMemo)(function() {
        return contentType === "event" ? "events" : "news";
    }, [
        contentType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
        directory: directoryLink,
        slug: slug,
        className: (Item_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Item_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                    image: previewImage,
                    className: (Item_module_default()).image
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Item_module_default()).arrow,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                        className: (Item_module_default()).icon,
                        name: "arrow_right"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                    className: (Item_module_default()).date,
                    color: "grey",
                    uppercase: true,
                    children: date
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                    className: (Item_module_default()).title,
                    color: "dark",
                    children: title
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content012/Item/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content012/GridView/GridView.module.scss
var GridView_module = __webpack_require__(24954);
var GridView_module_default = /*#__PURE__*/__webpack_require__.n(GridView_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content012/GridView/GridView.jsx








var GridView = function(param) {
    var title = param.title, description = param.description, contentType = param.contentType, events = param.events, articles = param.articles;
    var t = (0,translations/* useTranslation */.$)().t;
    var limitedItem = (0,react.useMemo)(function() {
        return contentType === "event" ? events.slice(0, 3) : articles.slice(0, 3);
    }, [
        articles,
        contentType,
        events
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
            className: (GridView_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (GridView_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                            className: (GridView_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            className: (GridView_module_default()).description,
                            color: "dark",
                            children: description
                        })
                    ]
                }),
                limitedItem.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: (GridView_module_default()).item
                    }, item), {
                        contentType: contentType
                    }), item.id);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                    slug: contentType === "article" ? "news" : "events",
                    className: (GridView_module_default()).link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (GridView_module_default()).text,
                        color: "dark",
                        uppercase: true,
                        children: contentType === "article" ? t("showAllNews") : t("showAllEvents")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var GridView_GridView = ((/* unused pure expression or super */ null && (GridView)));

;// CONCATENATED MODULE: ./src/components/widgets/content/Content012/GridView/index.js


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./src/components/widgets/content/Content012/SliderView/SliderView.module.scss
var SliderView_module = __webpack_require__(16392);
var SliderView_module_default = /*#__PURE__*/__webpack_require__.n(SliderView_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content012/SliderView/SliderView.jsx











var SliderView = function(param) {
    var title = param.title, description = param.description, contentType = param.contentType, events = param.events, articles = param.articles;
    var t = (0,translations/* useTranslation */.$)().t;
    var prevRef = react.useRef(null);
    var nextRef = react.useRef(null);
    var items = (0,react.useMemo)(function() {
        return contentType === "event" ? events : articles;
    }, [
        articles,
        contentType,
        events
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                className: (SliderView_module_default()).inner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SliderView_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                            className: (SliderView_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            className: (SliderView_module_default()).description,
                            color: "dark",
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((SliderView_module_default())["navigation-wrapper"], (0,_define_property/* default */.Z)({}, (SliderView_module_default()).position, Boolean(description))),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (SliderView_module_default())["slider-navigation"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: prevRef,
                                        className: classnames_default()((SliderView_module_default()).navigation, (SliderView_module_default())["navigation-prev"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            className: (SliderView_module_default()).icon,
                                            name: "arrow_slider_prev"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: nextRef,
                                        className: classnames_default()((SliderView_module_default()).navigation, (SliderView_module_default())["navigation-next"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            className: (SliderView_module_default()).icon,
                                            name: "arrow_slider_next"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SliderView_module_default()).slider,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SwiperLayout */.OJ, {
                    prevRef: prevRef,
                    nextRef: nextRef,
                    watchOverflow: true,
                    slidesPerView: "auto",
                    spaceBetween: 4,
                    slidesPerGroup: 1,
                    slidesOffsetAfter: 30,
                    children: items.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: (SliderView_module_default()).slide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                className: (SliderView_module_default()).item
                            }, item), {
                                contentType: contentType
                            }))
                        }, item.id);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                    slug: contentType === "article" ? "news" : "events",
                    className: (SliderView_module_default()).link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (SliderView_module_default()).text,
                        color: "dark",
                        uppercase: true,
                        children: contentType === "article" ? t("showAllNews") : t("showAllEvents")
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var SliderView_SliderView = ((/* unused pure expression or super */ null && (SliderView)));

;// CONCATENATED MODULE: ./src/components/widgets/content/Content012/SliderView/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content012/Content012.jsx








var Content012 = function(param) {
    var payload = param.payload;
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("012", payload.id);
    var ref = (0,PageData/* useCollectedData */.M)(instanceId, [
        {
            name: "events",
            defaultValue: []
        },
        {
            name: "articles",
            defaultValue: []
        }, 
    ]), events = ref.events, articles = ref.articles;
    var isMobile = (0,ViewMode/* useViewMode */.mJ)().isMobile;
    var ref1;
    var title = (ref1 = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var description = (ref2 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var contentType = (ref3 = payload === null || payload === void 0 ? void 0 : payload.contentType) !== null && ref3 !== void 0 ? ref3 : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content012_module_default()).wrapper,
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GridView, {
            title: title,
            description: description,
            contentType: contentType,
            events: events,
            articles: articles
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderView, {
            title: title,
            description: description,
            contentType: contentType,
            events: events,
            articles: articles
        })
    });
};
/* harmony default export */ var Content012_Content012 = (Content012);


/***/ }),

/***/ 74622:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content012_wrapper__EIlLf"};

/***/ }),

/***/ 24954:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"GridView_header__pC5Ab","title":"GridView_title__wA8qo","description":"GridView_description__lK3qO","link":"GridView_link__2tfXn"};

/***/ }),

/***/ 69819:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Item_wrapper__bTukt","title":"Item_title___eNtb","content":"Item_content__TD36t","date":"Item_date__Hnf3c","image":"Item_image__YQ_B8","arrow":"Item_arrow__aEufN"};

/***/ }),

/***/ 16392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"SliderView_header__9bRhN","title":"SliderView_title__kc88M","description":"SliderView_description__xO5_F","slider":"SliderView_slider__RJh16","slider-navigation":"SliderView_slider-navigation__TKBHg","position":"SliderView_position__8OE0M","navigation":"SliderView_navigation__W5His","navigation-prev":"SliderView_navigation-prev__HO9vu","navigation-next":"SliderView_navigation-next__Ekc6E","slide":"SliderView_slide___5qnh","link":"SliderView_link__ZfbC8"};

/***/ })

}]);